export const objectHasEmptyValues = (
  inputObj: Record<string, unknown>
): boolean => {
  for (const value of Object.values(inputObj)) {
    if (value) {
      return false;
    }
  }
  return true;
};
